export const ACCESS_TOKEN_SESSION_KEY = 'tj-popups-core-access-token';
